import React from 'react';
import {
    Page,
    Card,
    Layout,
    TextStyle,
    Badge,
    IndexTable,
    Icon,
    TextField,
    Stack,
    Button
} from '@shopify/polaris';
import {
    PlayCircleMajor
} from '@shopify/polaris-icons';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';

function OperationsIndex() {

    const history = useHistory();
    const [rules, setRules] = useState([]);
    const [searchTerm, setSearchTerm] = useState(null);

    useEffect(() => {

        fetch(`api/tagRules`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => setRules(data));
    }, []);

    let filteredRules = rules;

    if (searchTerm != null && searchTerm !== "") {
        filteredRules = rules.filter(_ => _.name.toUpperCase().indexOf(searchTerm.toUpperCase()) > -1);
    }

    const rowMarkup = filteredRules.map(
        ({ id, name, isExecuting, trigger, resourceType, type }, index) => (
            <IndexTable.Row id={id} key={id} position={index} onNavigation={navigateToRule}>
                <IndexTable.Cell>
                    <div data-primary-link>
                        <TextStyle variation="strong">{name}</TextStyle>
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>{resourceType}</IndexTable.Cell>
                <IndexTable.Cell>
                    {trigger === "Automatic" && <Badge status="success">{trigger}</Badge>}
                    {trigger === "Manual" && <Badge status="warning">{trigger}</Badge>}
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {isExecuting && <Icon source={PlayCircleMajor} color="highlight" />}
                </IndexTable.Cell>
                <IndexTable.Cell>{type}</IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Tag Rules</title>
            </Helmet>
            <Page title="Tag Rules"
                primaryAction={{ content: "Add Rule", onAction: addRule }}>
                <Layout>
                    <Layout.Section>
                        <Card title="Created Rules">
                            <Card.Section>
                                <Stack>
                                    <Stack.Item fill>
                                        <TextField value={searchTerm}
                                            placeholder="Search for rules to quickly find what you are looking for"
                                            onChange={_ => setSearchTerm(_)}
                                        />
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Button onClick={_ => setSearchTerm(null)}>Clear</Button>
                                    </Stack.Item>
                                </Stack>
                            </Card.Section>

                            <IndexTable
                                resourceName={{
                                    singular: 'rule',
                                    plural: 'rules',
                                }}
                                itemCount={filteredRules.length}
                                headings={[
                                    { title: 'Name' },
                                    { title: 'Resource' },
                                    { title: 'Trigger' },
                                    { title: 'Executing' },
                                    { title: 'Type' },
                                ]}
                                selectable={false}
                            >
                                {rowMarkup}
                            </IndexTable>
                        </Card>
                    </Layout.Section>
                </Layout>
            </Page>
        </div >
    );

    function navigateToRule(id) {
        history.push(`/tag-rules/${id}`);
    }

    function addRule() {
        history.push(`/tag-rules/list`);
    }
}

export default OperationsIndex;